import React from "react";

interface IWrapperProps {
  unwrap?: boolean;
  children: React.ReactNode;
  className?: string;
}

/**
 * Wrapper element for template content
 */
const ContentWrapper: React.FC<IWrapperProps> = props => {
  const { unwrap, children, className } = props;
  return (
    <div className={`content-wrapper ${className}`}>
      {unwrap ? <div className="unwrap">{children}</div> : children}
    </div>
  );
};

export default ContentWrapper;
